export const getAverageColor = async (picture) => {
  
  if (!picture)
    return false
  
  const data = await average(picture)
  return data
} 

const average = async (picture) => {
  const defaultRGB = {
    r:0,
    g:0,
    b:0
  }

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  let count = 0

  const averageData = await getImage(picture).then(image => {
    
    const height = canvas.height = image.naturalHeight || image.offsetHeight || image.height;
    context.drawImage(image, 0, 0)

    const data = context.getImageData(0, 0, 3, height)
    const pix = data.data
    
    for(let i = 0; i < pix.length; i = i + 4){
      count++
      defaultRGB.r += pix[i]
      defaultRGB.g += pix[i+1]
      defaultRGB.b += pix[i+2]
    }

    defaultRGB.r = ~~(defaultRGB.r/count)
    defaultRGB.g = ~~(defaultRGB.g/count)
    defaultRGB.b = ~~(defaultRGB.b/count)

    const acc = ( defaultRGB.r + defaultRGB.g + defaultRGB.b ) / 3
    return acc > 250 || acc < 5 ? `rgb(${defaultRGB.r}, ${defaultRGB.g}, ${defaultRGB.b})` : false
  }).catch((e) => {
    console.log(e)
  })

  return averageData
}

const getImage = (picture) => {
  return new Promise((resolve, reject) => {
    let image = new Image()

    image.onload = () => resolve(image)
    image.onerror = reject
    image.src = picture
  })
} 


// WEBPACK FOOTER //
// ./src/helpers/getAverageColor.js